var _ = require('lodash');
var dd = require('react-dd');
var esUtils = require('../utils/esUtils');

require('./SortableTable.less.js');

module.exports = dd.createClass({
	getInitialState: function(){
		return {sort_col: 0, sort_ascending: true, default_sort: {sort_col: 0, sort_ascending: true}};
	},
	componentWillReceiveProps: function(props){
		this.__updateDefaultSort(props);
	},
	componentDidMount: function(){
		this.__updateDefaultSort(this.props);
	},
	__updateDefaultSort: function(props){
		if(!props.default_sort){
			return;
		}
		var default_sort = this.state.default_sort;
		var changed = false;
		_.each(["sort_col", "sort_ascending"], function(f){
			if(default_sort[f] !== props.default_sort[f]){
				default_sort[f] = props.default_sort[f];
				changed = true;
			}
		});
		if(changed){
			this.setState({
				sort_col: default_sort.sort_col,
				sort_ascending: default_sort.sort_ascending,
				default_sort: default_sort
			});
		}
	},
	__clickCol: function(col_i){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			if(self.state.sort_col === col_i){
				self.setState({sort_ascending: !self.state.sort_ascending});
			}else{
				self.setState({sort_col: col_i, sort_ascending: true});
			}
		});
	},
	__determineHeaderOnClick: function(header, i) {
		if(_.isFunction(header.onClick)) {
			return header.onClick;
		}

		return header.sortable ? this.__clickCol(i) : null;
	},
	render: function(){
		var table = this.props.table;
		var sort_col = this.state.sort_col;
		var sort_ascending = this.state.sort_ascending;

		var rows = _.sortBy(table.rows, function(row){
			var col = row.cols[sort_col] || {};
			if(col.sortkey){
				return col.sortkey;
			}
			return col.body;
		});
		if(!sort_ascending){
			rows = rows.reverse();
		}

		return dd.table({className: 'SortableTable table table-condensed table-hover'},
			dd.thead(null,
				dd.tr(null,
					_.map(table.header, function(header, i){
						var classes = ['clickable'];

						// make sortable true by default
						if(!header.hasOwnProperty('sortable')) {
							header.sortable = true;
						}

						if(header.className){
							classes.push(header.className);
						}
						return dd.th({key: i, className: classes.join(' '), onClick: this.__determineHeaderOnClick(header, i)},
							_.isFunction(header.render) ? header.render() : header.body,
							' ',
							(header.sortable && sort_col === i) ? dd.i({className: 'fa fa-caret-' + (sort_ascending ? 'down' : 'up')}) : null
						);
					}, this)
				)
			),
			dd.tbody(null,
				rows.length === 0 ? dd.tr({className: 'emptytable'}, dd.td({colSpan: table.header.length, className: 'text-muted'}, 'nothing to report')) : _.map(rows, function(row, i){
					var tr_props = _.isPlainObject(row.props) ? row.props : {};
					tr_props.key = i;

					return dd.tr(tr_props,
						_.map(row.cols, function(col, i){
							var td_props = _.isPlainObject(col.props) ? col.props : {};
							td_props.key = i;

							return dd.td(td_props,
								dd.div({className: 'oneline-ellipsis'},
									_.isFunction(col.render) ? col.render() : col.body
								)
							);
						})
					);
				})
			)
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/SortableTable.js
// module id = 182
// module chunks = 0 1 2 3 4